export default __webpack_public_path__ + "27cf3268cfc8b1c5b3d128813733ca3e.svg";